import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {必須入力, 日付書式, 年月書式} from '@/type/validation/validator';
import {新さっぽろ脳神経外科病院受払一覧表出力条件型} from '@/type/custom/shinsapporo/report/report';

export default class 新さっぽろ脳神経外科病院受払一覧表検索条件チェッカー {
  単項目チェック結果: Error[];
  相関チェック結果: Error[];

  constructor(target: 新さっぽろ脳神経外科病院受払一覧表出力条件型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
    const 納品日範囲エラー = 在庫年月が入力されていない(target);
    this.相関チェック結果 = 納品日範囲エラー;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.concat(this.相関チェック結果)
      .map((value) => `${value.message}`);
  }
}

const 単項目チェックvalidators: Validator[] = [
  {
    name: '在庫年月',
    constraints: [
      {method: 必須入力, message: '在庫年月を入力してください'},
      {method: 年月書式, message: '在庫年月の書式が不正です'},
    ],
  },
];

function 在庫年月が入力されていない(target: 新さっぽろ脳神経外科病院受払一覧表出力条件型): Error[] {
  const errors: Error[] = [];
  if (target.在庫年月 === null) {
    return errors;
  }
  return errors;
}
